import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const LicenciaContext = createContext(null);

export function LicenciaProvider({ children }) {
  const { usuario } = useAuth();
  const [estado, setEstado] = useState('cargando'); // 'cargando' | 'ok' | 'sin_licencia' | 'inactiva'
  const [planInfo, setPlanInfo] = useState(null);

  const verificar = useCallback(() => {
    if (!usuario) return;

    // Superadmin siempre tiene acceso total
    if (usuario.is_superadmin) {
      setEstado('ok');
      return;
    }

    setEstado('cargando');
    api.get('/config/plan')
      .then(r => {
        setPlanInfo(r.data);
        if (r.data.es_superadmin) {
          setEstado('ok');
        } else if (!r.data.configurado) {
          setEstado('sin_licencia');
        } else {
          setEstado('ok');
        }
      })
      .catch(err => {
        // 403 del backend = licencia bloqueada
        const error = err.response?.data?.error;
        if (error === 'sin_licencia') setEstado('sin_licencia');
        else if (error === 'licencia_inactiva') setEstado('inactiva');
        else setEstado('ok'); // error de red → no bloquear
      });
  }, [usuario]);

  useEffect(() => {
    if (usuario) {
      verificar();
    } else {
      setEstado('cargando');
      setPlanInfo(null);
    }
  }, [usuario, verificar]);

  const logoUrl = planInfo?.logo_url || null;
  const moduloVentas = planInfo?.es_superadmin || !!planInfo?.suscripcion?.modulo_ventas;
  const moneda = planInfo?.moneda || 'COP';
  const codigoArea = planInfo?.codigo_area || null;
  const numeroEmpresa = planInfo?.numero_empresa || null;

  return (
    <LicenciaContext.Provider value={{ estado, planInfo, logoUrl, moduloVentas, moneda, codigoArea, numeroEmpresa, verificar }}>
      {children}
    </LicenciaContext.Provider>
  );
}

export function useLicencia() {
  return useContext(LicenciaContext);
}
